import { createBrowserLogger } from '@luckagents/shared/browser-logger.js'

type LogContext = Record<string, unknown>

const baseLogger = createBrowserLogger('portal')

export const logger = {
  debug: (message: string, context?: LogContext) => baseLogger.debug(context ?? {}, message),
  info: (message: string, context?: LogContext) => baseLogger.info(context ?? {}, message),
  warn: (message: string, context?: LogContext) => baseLogger.warn(context ?? {}, message),
  error: (message: string, context?: LogContext) => baseLogger.error(context ?? {}, message),
}
